module.exports = __webpack_public_path__ + "img/st8.f795cb72.svg";